<app-user-header class="d-lg-none"></app-user-header>

<div class="col-md-12 big-area ps-2 pe-2">

    <div class="wrapperi pb-4 ">

        <div class="col-12 p-0 row me-0 ms-0">
            <div class="col-12 mt-3 bg-f-w col-md-12 p-2">
                <p class="semiboldtextblue24 ">
                    <span>Hae työntekijöitä</span>
                </p>
<!--                 <div class="col-12 row m-0">


                    <div class="form-floating mb-2 col-12 col-lg-3  p-0">
                        <select (change)="filterProfiles('')" type="text" id="wellfare-area" placeholder="Valitse alue"
                            class="form-select">
                            <option value="every">Kaikki</option>
                            <option *ngFor="let data of wellfareAreas" value="{{data.id}}">{{data.name_fi}}</option>
                        </select>
                        <label for="md-type">Valitse alue</label>
                    </div>
                    <div class="form-floating mb-2 col-12 col-lg-3  ms-lg-3 p-0">
                        <input type="text" id="md-type" (keyup)="onSearchMdType()" placeholder="Hae..."
                            class="form-select">
                        <label for="md-type">Ammattinimike</label>
                        <div class="floating-search" *ngIf="show_mdtypes && show_mdtypes.length > 0">
                            <div class="floating-search-results">
                                <div class="floating-search-result" *ngFor="let data of show_mdtypes"
                                    (click)="mdtypeSelectedNew(data)">
                                    <p>{{data.name_fi}}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="form-floating mb-2 col-12 col-lg-3  ms-lg-3 p-0">
                        <select (change)="filterProfiles('')" type="text" id="work-possibilities"
                            placeholder="Valitse työaika" class="form-select">
                            <option value="all">Kaikki</option>
                            <option *ngFor="let data of workPossibilities" value="{{data.value}}">{{data.label}}
                            </option>

                        </select>
                        <label for="md-type">Työsuhde</label>
                    </div>
                </div> -->


                <div class="search-container">
                    <!-- Tags Input -->
                    <div class="tags-input-container">
                      <img src="../../assets/icons/search_icon_search.svg" class="input-icon" width="12px" />
                      <div class="tags-wrapper">
                        <span class="tag" *ngFor="let tag of tags; let i = index">
                          {{ tag.name_fi }}
                          <span class="remove-tag" (click)="removeTag(i)">
                            <img class="ms-2" src="../../assets/icons/close_icon.svg" />
                          </span>
                        </span>
                        <input
                          #tagsInput
                          type="text"
                          placeholder="Mitä etsit?"
                          class="tags-input"
                          [formControl]="tagsSearchControl"
                          (keydown.enter)="addTagEnter()"
                          (focus)="showTagsSuggestions = true"
                          (blur)="showTagsSuggestions = false"
                        />
                      </div>
                      <ul *ngIf="showTagsSuggestions && filteredTagsSuggestions.length > 0" class="suggestions-list">
                        <li
                          *ngFor="let suggestion of filteredTagsSuggestions"
                          (mousedown)="addTagFromSuggestion(suggestion)"
                          class="suggestion-item"
                        >
                          {{ suggestion.name_fi }}
                        </li>
                      </ul>
                    </div>
                  
                    <!-- Location Input -->
                    <div class="location-input-container">
                      <img src="../../assets/icons/location_gray.svg" class="input-icon" alt="Location icon" />
                      <div class="tags-wrapper">
                        <span class="tag" *ngFor="let location of locations; let i = index">
                          {{ location.name_fi }}
                          <span class="remove-tag" (click)="removeLocation(i)">
                            <img class="ms-2" src="../../assets/icons/close_icon.svg" />
                          </span>
                        </span>
                        <input
                          #locationInput
                          type="text"
                          placeholder="Maakunta"
                          class="location-input"
                          [formControl]="locationSearchControl"
                          (keydown.enter)="addLocationEnter()"
                          (focus)="showLocationSuggestions = true"
                          (blur)="showLocationSuggestions = false"
                        />
                      </div>
                      <ul
                        *ngIf="showLocationSuggestions && filteredLocationSuggestions.length > 0"
                        class="suggestions-list2"
                      >
                        <li
                          *ngFor="let suggestion of filteredLocationSuggestions"
                          (mousedown)="addLocationFromSuggestion(suggestion)"
                          class="suggestion-item"
                        >
                          {{ suggestion.name_fi }}
                        </li>
                      </ul>
                    </div>
                  
                    <!-- Search Button -->
                    <button class="search-button" (click)="onSearch()">
                      Etsi
                    </button>
                  </div>

                <div class="" *ngIf="wishList && wishList.length > 0;else no_wishes_found">



                    <div class="row">
                        <div class="col-md-4 col-lg-4 col-xl-3 mt-4" *ngFor="let opening of wishList">
                            <div class="" *ngIf="opening.type == 'wish';else banner_template">
                                <div class="formed-border-radius relative formed-shadow">
                                    <div class="wish-top-container bg-gray">
                                        <div class="p-3 d-flex justify-content-between">
                                            <div class="d-flex">
                                                <div class="new-badge" *ngIf="opening.wish_opens_for_all > current_epoch">
                                                    <p class="mb-0">Uusi</p>
                                                </div>

                                            </div>
                                            <div class="d-flex white-wish-heart-box"
                                                (click)="saveProfileToList(opening)">
                                                <img class="" width="13" src="../../assets/icons/bookmark_icon.svg" />
                                            </div>
                                        </div>

                                    </div>
                                    <div class="more-z" (click)="routeProfile(opening)">
                                        <div class="col-12 row m-0">
                                            <div class="boxer">
                                                <div class="transpa-bg cp">
                                                    <div class="d-flex justify-content-center profile-picture-mt">
                                                        <div *ngIf="opening['user']['profilePicture'];else no_image">
                                                            <img [ngClass]="opening['borderColor']" width="120"
                                                                onerror="this.src='../../assets/icons/formed_no_profile.svg'"
                                                                class="rounded-circle" height="120"
                                                                src="{{opening['user']['profilePicture']}}" alt="">
                                                        </div>
                                                        <ng-template #no_image>
                                                            <div class="">
                                                                <img [ngClass]="opening['borderColor']"
                                                                    class="rounded-circle"
                                                                    src="../../assets/icons/formed_no_profile.svg"
                                                                    width="120" alt="">

                                                            </div>
                                                        </ng-template>
                                                    </div>
                                                    <div class="mt-2 text-center">
                                                        <p class="semiboldtextblue90020 mb-0 ">
                                                            <span
                                                                *ngIf="opening.wishlist_version != 2">{{opening.user.mdType.grouping_name_fi}}</span>
                                                            <span
                                                                *ngIf="opening.wishlist_version == 2">{{opening.jobTitles[0].name_fi}}</span>
                                                        </p>
                                                        <div class="">
                                                            <p class="normaltextblue90016 f-os mb-0">
                                                                {{opening.user.firstName}}
                                                            </p>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div
                                                    class=" margin-10 d-flex flex-wrap justify-content-center d-lg-block">

                                                    <div class=""
                                                        *ngIf="opening.wishlist_version == 2; else version_one">
                                                        <div class="">
                                                            <div class="gray-box">
                                                                <div class="width-20 text-center">
                                                                    <img
                                                                        src="../../assets/icons/location_dark_blue.svg">
                                                                </div>
                                                                <p class="normaltextblue80016 f-os mb-0 ms-2 sm-m">
                                                                    {{opening['wellfareAreas'][0]['name_fi']}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="">
                                                            <div class="gray-box">
                                                                <div class="width-20 text-center">
                                                                    <img src="../../assets/icons/file_icon.svg">
                                                                </div>
                                                                <p class="normaltextblue80016 f-os mb-0 ms-2 sm-m">
                                                                    {{opening.workPossibility | workpossibility}}</p>

                                                            </div>
                                                        </div>
                                                        <div class="">
                                                            <div class="gray-box">
                                                                <div class="width-20 text-center">
                                                                    <img src="../../assets/icons/clock_icon_blue.svg">
                                                                </div>
                                                                <p class="normaltextblue80016 mb-0 f-os ms-2 sm-m">
                                                                    {{opening.worktimes |worktimes}}</p>

                                                            </div>
                                                        </div>
                                                        <div class="gb-box d-flex align-items-center">
                                                            <!-- Icon Section -->
                                                            <div class="icon-container d-flex align-items-center me-2">
                                                                <img src="../../assets/icons/jobs_icon.svg" alt="Icon">
                                                            </div>

                                                            <!-- Skills and +X Section -->
                                                            <div
                                                                class="d-flex justify-content-between flex-grow-1 align-items-center">
                                                                <!-- Skills List -->
                                                                <div class="skills-container">
                                                                    <span class="normaltextblue80016 me-1 f-os"
                                                                        *ngFor="let skill of opening.user.skills; let i = index">
                                                                        <span *ngIf="i < 3">
                                                                            {{ skill.name_fi }}<span
                                                                                *ngIf="i < 2">,</span>
                                                                        </span>
                                                                    </span>
                                                                </div>

                                                                <!-- +X Section -->
                                                                <div class="ms-2 badge-container">
                                                                    <span
                                                                        class="text-end skill-num-tag normaltextblue60016"
                                                                        *ngIf="opening.user.skills.length > 3">
                                                                        +{{ opening.user.skills.length - 3 }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <ng-template #version_one>
                                                        <div class="">
                                                            <div class="gray-box">
                                                                <div class="width-20 text-center">
                                                                    <img src="../../assets/icons/suitcase_blue.svg">
                                                                </div>
                                                                <p class="normaltextblue90016 f-os mb-0 ms-2 sm-m">
                                                                    {{opening.user.experience}}</p>
                                                                <p class=" f-os normaltextblue90016 mb-0 ms-1 sm-m">
                                                                    Vuotta
                                                                    kokemusta</p>
                                                            </div>
                                                        </div>
                                                        <div class="">
                                                            <div class="gray-box">
                                                                <div class="width-20 text-center">
                                                                    <img
                                                                        src="../../assets/icons/location_dark_blue.svg">
                                                                </div>
                                                                <p class="normaltextblue90016 f-os mb-0 ms-2 sm-m">
                                                                    {{opening['wellfareAreas'][0]['name_fi']}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="">
                                                            <div class="gray-box">
                                                                <div class="width-20 text-center">
                                                                    <img src="../../assets/icons/clock_icon_blue.svg">
                                                                </div>
                                                                <p class="normaltextblue90016 f-os mb-0 ms-2 sm-m">
                                                                    {{opening.workPossibility | workpossibility}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="">
                                                            <div class="gray-box">
                                                                <div class="width-20 text-center">
                                                                    <img src="../../assets/icons/wage_icon_blue.svg">
                                                                </div>
                                                                <p class="normaltextblue90016 f-os mb-0 ms-2 ">
                                                                    {{opening.wage}}<span
                                                                        *ngIf="opening.workPossibility == 'buy-service'">€/h</span>
                                                                    <span
                                                                        *ngIf="opening.workPossibility != 'buy-service'">€/kk</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </ng-template>


                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #banner_template>
                                <div (click)="routeAd(opening)"
                                    class="h-100 w-100 pointer formed-shadow relative formed-border-radius formed-shadow"
                                    style="cursor: pointer;background: url({{opening.image}}); background-size: cover">
                                    <div class="pointer h-100 w-100"></div>
                                </div>

                            </ng-template>
                        </div>
                    </div>
                </div>
                <div class="text-center mt-4" *ngIf="out_of_results == false;else no_content_to_load">
                    <button class="btn btn-formed-main-blue" (click)="loadMoreProfiles()">Lataa lisää</button>
                </div>
                <ng-template #no_content_to_load>
                    <div class="col-12">
                        <p class="semiboldtextblue24 text-center mt-4">
                            <span>Ei enempää toiveita</span>
                        </p>
                    </div>
                </ng-template>
            </div>
            <ng-template #no_wishes_found>
                <div class="col-12 row pb-4 mb-4 m-0 p-0" *ngIf="!isLoading">

                    <div class="col-12 col-lg-12 p-0">
                        <div class="bg-f-w p-4 ">
                            <p class="semiboldtextblue24 text-center mt-4">
                                <span>Ei hakutuloksia</span>
                            </p>
                            <div class="justify-content-center d-flex">
                                <img src="../../assets/images/no_search_found.png" height="270" alt="">

                            </div>
                            <div class="p-4">

                                <p class="normaltextblue16 text-center">
                                    <span>Ei hakutuloksia, kokeile toista hakua</span>
                                <div class="text-center justify-content-center d-flex">

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </ng-template>

        </div>
    </div>
</div>

<!-- Modal Check before deleting offer -->
<button data-bs-toggle="modal" id="save-list" data-bs-target="#save-list-modal" style="display:none"></button>
<div class="modal fade" id="save-list-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="">
                <div class="ps-4 pe-4 pt-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="icon-cont">
                                <img src="../../assets/icons/bookmark_filled.svg" width="14" alt="">
                            </div>
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Tallenna profiili listaan</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-confirm-modal" type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="" *ngIf="employer_lists.length > 0">
                    <div class="mb-20"*ngIf="already_in_list.length > 0">
                        <p class="normaltextblue90016 f-os">Profiili on jo alla olevissa listoissa</p>
                        <div *ngFor="let data of already_in_list" class="">
                            <div class="already-in-list-container mt-2 p-10">
                                <div class="justify-content-between align-items-center d-flex">
                                    <div class="list-name-cont">
                                        <p class="semiboldtextblue90016 mb-0 f-os">{{data.name}}</p>
                                    </div>
                                    <div class="remove-cont pointer">
                                        <p (click)="removeItemFromList()" class="semiboldtextblue60016 mb-0 f-os">Poista</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <p class="normaltextblue90016 f-os">
                        <span *ngIf="already_in_list.length > 0">Valitse toinen lista</span>
                        <span *ngIf="already_in_list.length == 0">Voit valita useita listoja</span>
                        </p>
                    <div class="accordion rekruu-accordion accordion-flush mb-20" id="accordionFlushExample">
                        <div class="accordion-item" style="border-radius: 10px;">
                            <h2 class="accordion-header" id="flush-headingOne">
                                <button class="accordion-button p-10 rekruu-accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false"
                                    aria-controls="flush-collapseOne">
                                    Valitse lista
                                </button>
                            </h2>
                            <div id="flush-collapseOne" class="accordion-collapse collapse"
                                aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                <div *ngFor="let list of employer_lists" (click)="selectList(list)"
                                    [ngClass]="list.selected ? 'rekruu-acc-selected-item' : 'p-10'" class="">
                                    <div class="pointer">
                                        <div class="d-flex justify-content-between">
                                            <div class="acc-name-container">
                                                <p [ngClass]="list.selected ? 'semiboldtextblue90016' : 'normaltextblue90016'"
                                                    class="f-os mb-0">{{list.name}}</p>
                                            </div>
                                            <div class="selected-item-container" *ngIf="list.selected">
                                                <img src="../../assets/icons/check_icon.svg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="create-new-container ">
                    <button class="btn btn-formed-light-blue w-100" data-bs-target="#exampleModalToggle2"
                        data-bs-toggle="modal" data-bs-dismiss="modal"><img class="me-3 margin-light-blue-icon"
                            src="../../assets/icons/plus_icon.svg" />Luo uusi
                        lista</button>
                </div>
                <div class="col 12 row m-0 mt-20" *ngIf="employer_lists.length > 0">
                    <div class="col-6 d-flex ps-0">
                        <button class="btn btn-formed-hollow w-100" id="close-save-list" data-bs-dismiss="modal">Peruuta</button>
                    </div>
                    <div class="col-6 pe-0">
                        <button class="btn btn-formed-main-blue w-100" (click)="saveToList()">Tallenna</button>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>

<!-- Create list modal -->

<div class="modal fade" id="exampleModalToggle2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2"
    tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="">
                <div class="p-4 d-flex justify-content-between">
                    <div class="">
                        <div class="d-inline-flex">
                            <div class="icon-cont">
                                <img src="../../assets/icons/bookmark_filled.svg" width="14" alt="">
                            </div>
                            <div class="ms-3 ">
                                <h5 class="semiboldtextblue90024" id="exampleModalLabel">Luo uusi lista</h5>
                            </div>
                        </div>
                    </div>
                    <div class="flex-end">
                        <button id="close-confirm-modal" type="button" class="btn-close" data-bs-dismiss="modal"
                            aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="15" alt="">
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="">
                    <input type="text" placeholder="Otsikko*" id="list-title" class="form-control">
                </div>
                <div class="mt-2">
                    <input type="text" placeholder="Kuvaus*" id="list-description" class="form-control">
                </div>

                <div class="accordion rekruu-accordion p-10 accordion-flush mt-2" id="accordionFlushExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-headingOne">
                            <button class="accordion-button rekruu-accordion-button collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false"
                                aria-controls="flush-collapseOne">
                                Valitse kenellä on oikeus katsoa listaa
                            </button>
                        </h2>
                        <div id="flush-collapseOne" class="accordion-collapse collapse"
                            aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <div class="pointer" *ngFor="let data of rights"
                                    [ngClass]="!data.selected ? '' : 'bg-selected-acc-item'"
                                    (click)="selectRight(data)">
                                    <div class="d-flex justify-content-between p-10 align-items-center">
                                        <div class="d-inline-flex">
                                            <div class="icon-container-acc icon-width me-2">
                                                <img src="{{data.icon_src}}" class="" alt="">
                                            </div>
                                            <div class="name">
                                                <p class="normaltextblue90016 mb-0">
                                                    <strong>{{data.highlighted}}</strong>{{data.normal}}</p>
                                            </div>
                                        </div>
                                        <div class="check-icon-container" *ngIf="data.selected">
                                            <img src="../../assets/icons/check_icon.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-12 p-10 row m-0 mb-20 pt-0">
                <div class="col-6 d-flex ps-1">
                    <button class="btn btn-formed-hollow w-100" id="close_create_new_list"
                        data-bs-dismiss="modal">Peruuta</button>
                </div>
                <div class="col-6 pe-1">
                    <button class="btn btn-formed-main-blue w-100" (click)="createANewList()">Tallenna</button>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Offscreen canvas -->


<button id="oc-profile" class="btn btn-primary" type="button" data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" style="display: none;"></button>
<div class="offcanvas offcanvas-end oc-33" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
    <div *ngIf="opening" class="oc-content">
        <div class="oc-header">
            <div class="d-flex justify-content-between">
                <div class="d-flex">
                    <div class="d-flex align-items-center">
                        <button class="btn-close" type="button" data-bs-dismiss="offcanvas" aria-label="Close">
                            <img src="../../assets/icons/close_icon.svg" width="20" alt="">
                        </button>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="white-wish-heart-box">
                        <img class="" width="20" src="../../assets/icons/sb_wishes.svg" />
                    </div>
                </div>
            </div>
        </div>
        <div class="transpa-bg cp">
            <div class="d-flex justify-content-center profile-picture-mt-lg">
                <div *ngIf="opening['profile']['profilePicture'];else no_image">
                    <img width="166" onerror="this.src='../../assets/icons/formed_no_profile.svg'"
                        class="rounded-circle" height="166" src="{{opening['profile']['profilePicture']}}" alt="">
                </div>
                <ng-template #no_image>
                    <div class="">
                        <img class="rounded-circle" src="../../assets/icons/formed_no_profile.svg" width="166" alt="">
                    </div>
                </ng-template>
            </div>
            <div class="mt-2 text-center">
                <p class="semiboldtextblue90024 mb-1">
                    <span *ngIf="opening.wishlist_version != 2">{{opening.profile.mdType.grouping_name_fi}}</span>
                    <span *ngIf="opening.wishlist_version == 2">{{opening.jobTitles[0].name_fi}}</span>
                </p>

                <div class="">
                    <p class="normaltextblue90020OS mb-0">{{opening.profile.firstName}}</p>
                </div>
            </div>
            <div class="d-flex w-100 justify-content-center">
                <div class="">
                    <div class="text-center justify-content-center d-flex">
                        <button class="text-center btn btn-formed-main-blue mt-2 mb-3" (click)="sendMessage()"><img
                                class="me-2 neg-margin-2" width="18"
                                src="../../assets/icons/paperplane_white.svg" />Lähetä viesti</button>
                    </div>

                </div>
            </div>
            <div class="mb-3" *ngIf="contacted_by.length > 0">
                <div class="justify-content-center flex-column flex-lg-row d-lg-flex justify-content-lg-center"
                    *ngFor="let data of contacted_by">
                    <div class=" ps-4 ps-md-0 me-3">
                        <div [ngClass]="opening.can_open ? '' : ''"
                            class=" ms-3 ms-lg-0 justify-content-center align-items-center d-flex">
                            <p class="cbtext mb-0 "><img class="me-2 mb-1" width="30" height="30"
                                    src="../../assets/icons/contactedby.svg" />{{data.employer.firstName}} kontaktoinut
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            <div class="wish-box">
                <div class="wish-box-general">
                    <div class="d-flex">
                        <img class="me-2" src="../../assets/icons/gradient_blue_heart.svg" />
                        <p class="gradient-text mb-0">Käyttäjän toive</p>
                    </div>
                    <div class="d-flex mt-2">
                        <div class="icon-width text-center">
                            <img src="../../assets/icons/location_dark_blue.svg">
                        </div>
                        <div class="">
                            <p class="normaltextblue80016 mb-0 f-os ms-text-start sm-m">
                                {{opening['wellfareAreas'][0]['name_fi']}}</p>
                        </div>
                    </div>

                    <div class="d-flex mt-2">
                        <div class="icon-width text-center">
                            <img src="../../assets/icons/file_icon.svg">
                        </div>
                        <div class="">
                            <p class="normaltextblue80016 mb-0 f-os ms-text-start sm-m">
                                {{opening.workPossibility | workpossibility}}</p>
                        </div>
                    </div>

                    <div class="d-flex mt-2">
                        <div class="icon-width text-center">
                            <img src="../../assets/icons/clock_icon_blue.svg">
                        </div>
                        <div class="">
                            <p class="normaltextblue80016 mb-0 f-os ms-text-start sm-m">
                                {{opening.worktimes | worktimes}}</p>
                        </div>
                    </div>

                </div>
                <div class="wish-box-description mt-20">
                    <div class="d-flex">
                        <img class="me-2" src="../../assets/icons/gradient_blue_heart.svg" />
                        <p class="gradient-text mb-0">Toiveen kuvaus</p>
                    </div>
                    <div class="mt-2">
                        <p class="normaltextblue80016 mb-0 f-os">{{opening.description}}</p>
                    </div>
                </div>
            </div>
            <div class="bubble-box mt-20">
                <p class="gradient-text mb-0">Profiili</p>
                <div class="d-flex mt-2">
                    <div class="icon-width text-center">
                        <img src="../../assets/icons/language_icon.svg">

                    </div>
                    <div class="">
                        <p class="normaltextblue80016 mb-0 f-os ms-text-start sm-m">
                            {{opening.display_lang}}</p>
                    </div>
                </div>
                <div class="mt-10">
                    <p class="gradient-text mb-0">Tietoja minusta</p>
                    <div class="mt-2">
                        <p class="normaltextblue80016 mb-0 f-os">{{opening.profile.description}}</p>
                    </div>
                </div>
                <div class="mt-10" *ngIf="opening.profile.skills && opening.profile.skills.length > 0">
                    <p class="mb-0 normaltextgray50016">Taidot & tutkinnot</p>
                    <div class="d-flex flex-wrap">
                        <div class="blue-gradient-border me-2 mt-2" *ngFor="let skill of opening.profile.skills">
                            <p class="mb-0">{{skill.name_fi}}</p>
                        </div>

                    </div>
                </div>
                <div class="mt-10" *ngIf="opening.profile.cv && opening.profile.cv.length > 0">
                    <p class="mb-0 normaltextgray50016">Työkokemus</p>
                    <div class="bg-blue100 mt-2" *ngFor="let cv of opening.profile.cv">
                        <p class="mb-0 semiboldtextblue90016">{{cv.position}}</p>
                        <p class="mb-0 normaltextgray40014">{{cv.company}}</p>
                        <p class="d-flex normaltextblue60016 mb-0">
                            <span>{{cv.startDate.month.id}}.{{cv.startDate.year}}</span>-<span>{{cv.endDate != "" ?
                                cv.endDate.month.id + '.' + cv.endDate.year : ""}}</span>
                        </p>
                        <p class="mt-1 normaltextblue80016 mb-0">{{cv.description}}</p>
                    </div>


                </div>
                <div class="mt-10" *ngIf="opening.profile.job_titles && opening.profile.job_titles.length > 0">
                    <p class="mb-0 normaltextgray50016">Kiinnostunut myös näistä työnimikkeistä</p>
                    <div class="d-flex flex-wrap">
                        <div class="blue-gradient-border me-2 mt-2" *ngFor="let title of opening.profile.job_titles">
                            <p class="mb-0">{{title.name_fi}}</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
